import component from "./components";

export default store => ({
  path: "journal",
  component,
  childRoutes: [],
});
